import { http, HttpResponse } from 'msw';
import { salesMocks } from '../mocks';

export const statsHandler = http.get(
  '*/00000000-0000-0000-0000-000000000000/sales/stats*',
  () => HttpResponse.json(salesMocks.stats)
);

export const sumHandler = http.get('*/sales/sum*', () =>
  HttpResponse.json(salesMocks.sum)
);

export const deviceSales = http.get('*device/:deviceId/sales?*', () =>
  HttpResponse.json(salesMocks.deviceSales)
);

export const salesDynamics = http.get('*sales/dynamics?*', () =>
  HttpResponse.json(salesMocks.salesDynamics)
);
